// Vive Glow — etkileşimler
(function () {
  // Mobil menü
  var toggle = document.getElementById('MenuToggle')
  var nav = document.getElementById('SiteNav')
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open')
    })
  }

  // Scroll reveal
  var revealEls = document.querySelectorAll('.reveal')
  if ('IntersectionObserver' in window && revealEls.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.12 }
    )
    revealEls.forEach(function (el) { observer.observe(el) })
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible') })
  }

  // Varyant değişince fiyat güncelle
  var variantSelect = document.getElementById('VariantSelect')
  var priceEl = document.getElementById('ProductPrice')
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex]
      if (opt && opt.dataset.price) priceEl.textContent = opt.dataset.price
    })
  }

  // Sticky Add-to-Cart: asıl buton ekrandan çıkınca altta belirir
  var stickyBar = document.getElementById('StickyAtc')
  var mainBtn = document.getElementById('AddToCartBtn')
  if (stickyBar && mainBtn && 'IntersectionObserver' in window) {
    var atcObserver = new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting
        stickyBar.classList.toggle('is-visible', !visible)
        stickyBar.setAttribute('aria-hidden', visible ? 'true' : 'false')
      },
      { threshold: 0 }
    )
    atcObserver.observe(mainBtn)

    var stickyBtn = document.getElementById('StickyAtcBtn')
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.getElementById('ProductForm')
        if (form) form.submit()
      })
    }
  }
})()
